import { render, staticRenderFns } from "./NewsDetailEdit.vue?vue&type=template&id=14c8df15&scoped=true&"
import script from "./NewsDetailEdit.vue?vue&type=script&lang=js&"
export * from "./NewsDetailEdit.vue?vue&type=script&lang=js&"
import style0 from "./NewsDetailEdit.vue?vue&type=style&index=0&id=14c8df15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c8df15",
  null
  
)

export default component.exports